import React from 'react';
import {MasterLayout} from 'components/layouts';
import {AnnouncementDetailContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class AnnouncementDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.AnnouncementDetail;
  }

  render() {
    return (
      <MasterLayout>
        <AnnouncementDetailContainer params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default MemberZone(AnnouncementDetail);



// WEBPACK FOOTER //
// ./pages/users/AnnouncementDetail.jsx